/**
 * Category API Types
 */

import type { ApiResponse } from './index';

export const CATEGORY_TYPE = {
  CATEGORY: 1,
  SUB_CATEGORY: 2,
} as const;

export type CategoryType = typeof CATEGORY_TYPE[keyof typeof CATEGORY_TYPE];

export interface Category {
  _id: string;
  name: string;
  internalName: string;
  type: CategoryType;
  parentId?: string;
  categoryNo?: number;
  subCategoryNo?: number;
  status: boolean;
  isDeleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateCategoryPayload {
  name: string;
  internalName: string;
  type: CategoryType;
  parentId?: string; // Required when type = 2
  status?: boolean;
}

export interface UpdateCategoryPayload {
  name?: string;
  internalName?: string;
  status?: boolean;
}

export interface GetCategoriesParams {
  parentId?: string; // Filter subcategories by parent category
  search?: string; // Search query
  page?: number;
  limit?: number;
  offset?: number;
}

export interface CategoryListData {
  totalCount?: number;
  list?: Category[];
}

// Response can be either direct array or paginated object
export interface GetCategoriesResponse extends ApiResponse<Category[] | CategoryListData> {}
export interface GetCategoryResponse extends ApiResponse<Category> {}
export interface CreateCategoryResponse extends ApiResponse<Category> {}
export interface UpdateCategoryResponse extends ApiResponse<Category> {}
export interface DeleteCategoryResponse extends ApiResponse<void> {}

